window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

$.expr[':'].textEquals = $.expr.createPseudo(function (arg) {
    return function (elem) {
        return $(elem).text().trim().match("^" + arg + "$");
    };
});

// Navbar mobile transparention toggle on scroll

$.fn.fixNavbarMobile = function () {
    if (screen.width < 992) {
        if (window.scrollY > 30 || $('.navbar-profile-company, body.mobile-search-open, body.login-modal-open').length) {
            $('.navbar-homepage-mobile > div').addClass('bg-dark');
        } else {
            $('.navbar-homepage-mobile > div').removeClass('bg-dark');
        }
    }
}

window.onscroll = function (e) {
    $.fn.fixNavbarMobile();
}

window.onresize = function (e) {
    $.fn.fixNavbarMobile();
}

$.fn.fixNavbarMobile();


// select with optional input
$.fn.selectWithOptionalInput = function () {
    this.each(function () {
        var suffix = '_optional_input';
        var source_select = $(this);
        var target_name = source_select.attr('name') + suffix;
        if (source_select.find('.editable[value="other"]').length == 0) {
            source_select.append('<option class="editable" value="other">+ Dodaj nową</option>');
            source_select.after('<input type="text" class="form-control" name="' + target_name + '" style="display:none;" placeholder="Wpisz nową pozycję" />')
            var source_select_editable = $(this).find('.editable');
            var target_input = $(this).siblings('[name="' + target_name + '"]');

            source_select.change(function () {
                var selected = $('option:selected', this).attr('class');
                var optionText = source_select_editable.text();

                if (selected == "editable") {
                    target_input.show().focus();
                    source_select.hide();
                    target_input.keyup(function () {
                        var editText = target_input.val();
                        source_select_editable.val(editText);
                        source_select_editable.html(editText);
                    });

                } else {
                    target_input.hide();
                }
            });

            if (source_select.find('option').length <= 1) {
                target_input.show().focus();
                source_select.hide();
                target_input.keyup(function () {
                    var editText = target_input.val();
                    source_select_editable.val(editText);
                    source_select_editable.html(editText);
                    source_select.val(editText)
                });
            }
        }
    });
};

window.roundToMinutes = function (date = Date.now(), minuteInterval = 15) {
    const ms = 1000 * 60 * minuteInterval; // convert minutes to ms
    return new Date(Math.round(date / ms) * ms);
}

window.higlightSuggestedSlotHours = function () {
    $('label.quick_booking_ajax.highlighted_hour').removeClass('highlighted_hour')
    let day1 = $('main .search_filter[name="search_filter_date"]').val();
    let hour1 = $('main .search_filter[name="search_filter_time"]').val()
    let day2 = (roundToMinutes(new Date(), 15)).toJSON().slice(0, 10);
    let hour2 = (roundToMinutes(new Date(), 15)).toLocaleTimeString().slice(0, 5);
    $('label.quick_booking_ajax[data-day="' + day1 + '"][data-hour="' + hour1 + '"], label.quick_booking_ajax[data-day="' + day2 + '"][data-hour="' + hour2 + '"]').addClass('highlighted_hour');
}

window.toggleFullscreen = function (event) {
    var element = document.body;

    if (event instanceof HTMLElement) {
        element = event;
    }

    var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

    element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () {
        return false;
    };
    document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () {
        return false;
    };

    isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
}

$.loadRecommendedBoxLocation = function (location_name, loading_indicator = true) {
    if ($('#recommended_box_wrap').length) {
        $.ajax({
            type: "POST",
            url: "/ajax/discover",
            dataType: "json",
            data: {
                location: location_name,
            },
            success: function (response) {
                if (response.city.url) {
                    // $('.recommended_box_city').html('<a href="' + response.city.url + '" class="btn btn-sm btn-outline-primary">' + response.city.name + '</a>');
                    $('.recommended_box_city').html(' (' + response.city.name + ')');
                } else {
                    $('.recommended_box_city').html('');
                }

                for (let key in response.sections) {
                    if (response.sections[key].url) {
                        $('.recommended_section_' + key).find('.recommended_box_more').attr('href', response.sections[key].url).removeClass('visually-hidden');
                    } else {
                        $('.recommended_section_' + key).find('.recommended_box_more').attr('href', '').addClass('visually-hidden');
                    }

                    if (response.sections[key].data) {
                        $('.recommended_section_' + key).find('.recommended_box_name').html(response.sections[key].name);
                        $('.recommended_section_' + key).find('.recommended_box_content').html(response.sections[key].data);
                        $('.recommended_section_' + key).show();
                    } else {
                        $('.recommended_section_' + key).hide();
                        $('.recommended_section_' + key).find('.recommended_box_name').html('');
                        $('.recommended_section_' + key).find('.recommended_box_content').html('');
                    }
                }

                $('.nearest_hours_available_lazyload').each(function () {
                    nearestHoursObserver.observe($(this).get(0));
                })

                if (response.sections.places.data) {
                    initSwiperPlaces();
                }

                let featured_slide = response.hero.slides[0];

                if (featured_slide) {
                    $('main .module_search').fadeTo('fast', 0.3, function () {
                        $(this).css("background-image", 'url("' + featured_slide.image + '"), linear-gradient(rgb(94 94 94) 0%, rgb(0 0 0 / 0%) 50%)');
                    }).fadeTo('fast', 1);

                    if (!$('main .module_search .food-selection').hasClass('d-flex')) {
                        $('main .module_search .food-selection').fadeTo('fast', 0.3, function () {
                            $(this).addClass('d-flex');
                        }).fadeTo('fast', 1);
                    }

                    $('main .module_search .food-selection a').attr('href', featured_slide.url).text(featured_slide.name);
                } else {
                    $('main .module_search').fadeTo('fast', 0.3, function () {
                        $(this).css("background-image", 'url("' + response.hero.fallback_image + '"), linear-gradient(rgb(94 94 94) 0%, rgb(0 0 0 / 0%) 50%)');
                    }).fadeTo('fast', 1);

                    if ($('main .module_search .food-selection').hasClass('d-flex')) {
                        $('main .module_search .food-selection').fadeTo('fast', 0.7, function () {
                            $(this).removeClass('d-flex');
                        }).fadeTo('fast', 0);
                    }
                }
            },
            beforeSend: function () {
                if (loading_indicator) {
                    $("#loading-indicator").fadeIn('fast');
                }
            },
            complete: function () {
                if (loading_indicator) {
                    $("#loading-indicator").fadeOut('fast');
                }
            }
        });
    }
}

$.randomString = function (length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    var string_length = length;
    var randomstring = '';
    for (var i = 0; i < string_length; i++) {
        var rnum = Math.floor(Math.random() * chars.length);
        randomstring += chars.substring(rnum, rnum + 1);
    }
    return randomstring;
}

$.cleanOpenedWindows = function (without) {
    if (without != 'login-modal') {
        $('body').removeClass('login-modal-open');
    }
    if (without != 'quick-public-profile-modal') {
        $('body').removeClass('quick-public-profile-modal-open');
    }
    if (without != 'mobile-search') {
        $('body').removeClass('mobile-search-open');
    }
    if (without != 'sidebar') {
        $(".sidebar").removeClass('toggled');
        $(".sidebar-toggle").addClass('collapsed');
    } else {
        $('.navbar .navbar-toggler').addClass('collapsed');
    }
}

$.loadQuickBookingPanel = function (type, id, day, hour, people, kind, availability_tag, event_id) {
    const siteUrl = $('[name="site-url"]').attr('content');
    const campaign = $('meta[name="campaign"]').attr('content');
    let url;

    if (type === 'create') {
        const params = {day, hour, people, kind, campaign, availability_tag, event_id};

        const searchParams = new URLSearchParams();
        for (const key in params) {
            if (params[key]) {
                searchParams.append(key, params[key]);
            }
        }
        const queryString = searchParams.toString();

        url = `${siteUrl}/booking/${id}?${queryString}`;
    } else if (type === 'update') {
        url = `${siteUrl}/booking/update-reservation/${id}`;
    } else {
        alert(`Widget: ${lang.get('javascript.error_generic')}`);
    }

    if (window.frameElement) {
        location.href = url;
    } else {
        document.body.insertAdjacentHTML('afterbegin', '<div id="zjedzmy-widget-wrap" class="zjedzmy-widget-bg"><div id="quick_booking_loading_indicator"><div><span class="fa-stack fa-2x"><i class="fad fa-spinner-third fa-spin fa-stack-2x text-secondary" style="opacity: 0.6;"></i><i class="fa-kit-duotone fa-zjedzmy-smile fa-stack-1x fa-bounce" style="--fa-primary-color: #FFCC00; --fa-secondary-color: black; --fa-secondary-opacity: 1.0;"></i></span></div></div><iframe id="quick_booking_iframe" allowtransparency="true" frameborder="0" width="100%" height="100%" marginwidth="0" marginheight="0" src="' + url + '"></iframe></div>');
    }

    var iframe = document.getElementById("quick_booking_iframe");
    var loading = document.getElementById("quick_booking_loading_indicator");
    iframe.style.display = "none";
    loading.style.display = "block";
    iframe.onload = function () {
        iframe.style.display = "";
        loading.style.display = "none";
    };
}

$.attachDragToScroll = function (element) {
    let mouseDown = false;
    let startX, scrollLeft;
    let isDragging = false;

    let startDragging = function (e) {
        if (element.scrollWidth <= element.clientWidth) {
            return;
        }
        mouseDown = true;
        isDragging = false;
        startX = e.pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;
    };
    let stopDragging = function (event) {
        mouseDown = false;
        if (isDragging) {
            setTimeout(() => {
                isDragging = false;
                Array.from(element.children).forEach(c => c.style.pointerEvents = '');
                element.style.cursor = '';
            }, 100);
        }
    };

    element.addEventListener('mousemove', (e) => {
        e.preventDefault();
        if (!mouseDown) {
            return;
        }
        const x = e.pageX - element.offsetLeft;
        const scroll = x - startX;
        element.scrollLeft = scrollLeft - scroll;
        if (Math.abs(scroll) > 5) {
            if (!isDragging) {
                isDragging = true;
                Array.from(element.children).forEach(c => c.style.pointerEvents = 'none');
                element.style.cursor = 'pointer';
            }
        }
    });

    // Add the event listeners
    element.addEventListener('mousedown', startDragging, false);
    element.addEventListener('mouseup', stopDragging, false);
    element.addEventListener('mouseleave', stopDragging, false);
}

$.shortIconAnimation = function (el, animation) {
    el.addClass('faa-' + animation + ' faa-fast animated');
    setTimeout(function () {
        el.removeClass('faa-' + animation + ' faa-fast animated');
    }, (animation == 'flash') ? 500 : 1000);
}

$.closeQuickBookingPanelFromTheIframe = function () {
    if (window.frameElement) {
        window.parent.document.getElementById('zjedzmy-widget-wrap').parentNode.removeChild(window.parent.document.getElementById('zjedzmy-widget-wrap'));
    } else {
        // Walkaround for: SecurityError: Blocked a frame with origin from accessing a cross-origin frame
        window.parent.postMessage({
            'action': 'closeQuickBookingPanel',
        }, "*");
    }
}

window.flatpickrFormatTodayTomorrow = function (selected, dateString, flatpickr) {
    const today = new Date()
    let tomorrow = new Date()
    tomorrow.setDate(today.getDate() + 1)

    if (selected.length != 1) return

    if (selected[0].toDateString() === today.toDateString()) {
        flatpickr._input.value = lang.get('javascript.today')
        return
    }

    if (selected[0].toDateString() === tomorrow.toDateString()) {
        flatpickr._input.value = lang.get('javascript.tommorow')
    }
}

// Detect iframe
if (window.parent !== window) {
    document.documentElement.classList.add('inside-iframe');
}

// Dark/Light mode theme switcher
window.setTheme = function (type) {
    if (type == 'dark') {
        $('html').attr('data-bs-theme', 'dark');
        Cookies.set('dark-mode-enabled', true, {expires: 365});
        $('.theme-icon').removeClass('fa-sun').addClass('fa-moon');
    } else {
        $('html').attr('data-bs-theme', 'light');
        Cookies.set('dark-mode-enabled', false, {expires: 365});
        $('.theme-icon').removeClass('fa-moon').addClass('fa-sun');
    }
}

// Auto add cart counter to buttons:
window.updateCartCounter = function (prefix, cart_counter) {
    var cart_key = prefix + '_' + cart_counter.data('id');
    var totalCount = 0;
    if (localStorage.getItem(cart_key) != null) {
        cart = JSON.parse(localStorage.getItem(cart_key));
        for (var item in cart) {
            totalCount += cart[item].count;
        }
        if (totalCount > 0) {
            if (cart_counter.find('.quick_booking_cart_counter').length) {
                if (parseInt(cart_counter.find('.quick_booking_cart_counter').text()) != totalCount) {
                    cart_counter.find('.quick_booking_cart_counter').html('<i class="fal fa-shopping-cart"></i> ' + totalCount);
                    $.shortIconAnimation($('.quick_booking_cart_counter .fa-shopping-cart'), 'tada');
                }
            } else {
                cart_counter.append('<span class="ms-4 quick_booking_cart_counter"><i class="fal fa-shopping-cart me-1"></i> ' + totalCount + '</span>');
            }
        } else {
            cart_counter.find('.quick_booking_cart_counter').remove();
        }
    }
}

window.shoppingCart = function (cart_key) {
    let cart = [];

    // Constructor
    function Item(id, name, price, count) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.count = count;
    }

    function saveCart() {
        localStorage.setItem(cart_key, JSON.stringify(cart));
    }

    function loadCart() {
        cart = JSON.parse(localStorage.getItem(cart_key));
    }

    if (localStorage.getItem(cart_key) != null) {
        loadCart();
    }


    var obj = {};

    // Add to cart
    obj.addItemToCart = function (id, name, price, count) {
        for (var item in cart) {
            if (cart[item].id === id) {
                cart[item].count++;
                saveCart();
                return;
            }
        }
        var item = new Item(id, name, price, count);
        cart.push(item);
        saveCart();
    }

    // Remove item from cart
    obj.removeItemFromCart = function (id) {
        for (var item in cart) {
            if (cart[item].id === id) {
                cart[item].count--;
                if (cart[item].count === 0) {
                    cart.splice(item, 1);
                }
                break;
            }
        }
        saveCart();
    }

    // Remove all items from cart
    obj.removeItemFromCartAll = function (id) {
        for (var item in cart) {
            if (cart[item].id === id) {
                cart.splice(item, 1);
                break;
            }
        }
        saveCart();
    }

    // Clear cart
    obj.clearCart = function () {
        cart = [];
        saveCart();
    }

    // Count cart
    obj.totalCount = function () {
        var totalCount = 0;
        for (var item in cart) {
            totalCount += cart[item].count;
        }
        return totalCount;
    }

    // Total cart
    obj.totalCart = function () {
        var totalCart = 0;
        for (var item in cart) {
            totalCart += cart[item].price * cart[item].count;
        }
        return Number(totalCart.toFixed(2));
    }

    // List cart
    obj.listCart = function () {
        var cartCopy = [];
        for (i in cart) {
            item = cart[i];
            itemCopy = {};
            for (p in item) {
                itemCopy[p] = item[p];

            }
            itemCopy.total = Number(item.price * item.count).toFixed(2);
            cartCopy.push(itemCopy)
        }
        return cartCopy;
    }
    return obj;
}

$(document).ready(function () {
    window.initSwiperHours = () => {
        $('.swiper-hours:not(.swiper-container-initialized)').each(function () {
            new Swiper($(this)[0], {
                mousewheel: {
                    forceToAxis: true,
                    sensitivity: 0.3,
                    thresholdDelta: 0,
                },

                slideToClickedSlide: true,
                centeredSlides: true,
                initialSlide: 2,

                navigation: {
                    nextEl: $(this).siblings('.swiper-button-next')[0],
                    prevEl: $(this).siblings('.swiper-button-prev')[0],
                },

                slidesPerView: 'auto',
                slidesPerGroupAuto: true,
            });
        });
    }

    initSwiperHours();

    // Infinite scrolling observer
    let infiniteScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((el) => {
            if (!el.isIntersecting) {
                return false;
            }
            let linkTrigger = $(el.target);

            $.ajax({
                url: linkTrigger.prop('href'),
                dataType: 'html',
                beforeSend: function () {
                    linkTrigger.html(`<div class="w-100 d-flex justify-content-center align-items-center"><i class="fa fa-spinner fa-2x faa-spin animated"></i></div>`)
                },
            })
                .done(function (data) {
                    let dataHtml = $(data).fadeOut(0)
                    linkTrigger.parents('.infinite-scroll-content').append(dataHtml);
                    dataHtml.fadeIn();
                    if (linkTrigger.siblings('.infinite-scroll-link').last().get(0)) {
                        infiniteScrollObserver.observe(linkTrigger.siblings('.infinite-scroll-link').last().get(0));
                    }

                    linkTrigger.remove();
                })
                .fail(function (response) {
                    Swal.fire({
                        icon: 'error',
                        title: lang.get('javascript.error_generic'),
                        text: response.status,
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    })
                });
        })
    }, {
        root: null,
        threshold: 0.5,
        rootMargin: '0px 0px 300px 0px'
    })

    // observe all infinite scroll links
    $('.infinite-scroll-link').get().forEach((el) => {
        infiniteScrollObserver.observe(el)
    })

    // Sticky headers observer
    const stickyObserver = new IntersectionObserver((entries) => {
        entries.forEach((el) => {
            if (!el.isIntersecting) {
                $(el.target).siblings('.sticky-container').addClass('stuck')
            } else {
                $(el.target).siblings('.sticky-container').removeClass('stuck')
            }
        })
    }, {
        threshold: 1,
        rootMargin: '0px 0px 200px 0px'
    })

    window.observeStickyElements = function () {
        $('.sticky-sentinel').each(function () {
            stickyObserver.observe($(this).get(0));
        })
    }

    observeStickyElements();

    // Companies Box Nearest Hours lazy load
    window.nearestHoursObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
                const timeoutId = setTimeout(() => {
                    lazyLoadNearestHours($(entry.target))
                    $(entry.target).removeData('lazyloadTimeout')
                }, 450)
                $(entry.target).data('lazyloadTimeout', timeoutId)
            } else {
                const timeoutId = $(entry.target).data('lazyloadTimeout')
                if (timeoutId) {
                    clearTimeout($(entry.target).data('lazyloadTimeout'))
                }
            }
        })
    }, {
        rootMargin: '100px 0px 300px 0px'
    })

    window.observeNearestHours = function () {
        $('.nearest_hours_available_lazyload').each(function () {
            nearestHoursObserver.observe($(this).get(0));
        })
    }

    observeNearestHours();


    // Promotion overlay toggle
    $(document).on('click', '.toggle_promotion', function () {
        $('#promotion_overlay_' + $(this).data('companyid')).toggleClass('show');
        $(this).toggleClass('faa-pulse animated');
        $(this).find('.fa-stack-1x').toggleClass('fa-percent').toggleClass('fa-times');
    });

    // Tooltips
    $('[data-bs-toggle="tooltip"]').tooltip();

    // CSRF token
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // confetti on click
    $(document).on('click', '.confetti-click', function (event) {
        let confetti = window.confetti.create(null, {
            resize: true,
        });

        confetti({
            particleCount: 80,
            spread: (event.clientY / window.innerHeight) > 0.30 ? 100 : 360,
            ticks: 40,
            gravity: 0.6,
            startVelocity: 40,
            origin: {
                x: event.clientX / window.innerWidth,
                y: event.clientY / window.innerHeight
            },
        });
    });

    $('.nav-tabs-flat, .horizontal-scroll-nav').each(function () {
        $.attachDragToScroll($(this)[0])
    })

    // Favoriteable
    $(document).on('click', '.favoriteable', function () {
        const $btn = $(this);
        if ($btn.hasClass('blocked')) return;

        const type = $btn.data('favoriteable');
        const id = $btn.data('id');
        const $related = $(`.favoriteable[data-favoriteable="${type}"][data-id="${id}"]`);
        const $icons = $related.find('.fa-inverse');

        // Predicted state logic
        const isFavorited = $btn.find('.fa-inverse').hasClass('fas');
        const predictedState = !isFavorited;

        const syncUI = (state) => {
            $related.each(function () {
                const $el = $(this);
                const $icon = $el.find('.fa-inverse');
                const $userIcon = $el.find('.fa-user-plus, .fa-user-check');
                const $text = $el.find('.favoriteable-text');

                const hasText = $text.length > 0;
                if (hasText) {
                    const oldWidth = $text.width();
                    $text.css({
                        width: oldWidth,
                        display: 'inline-block',
                        overflow: 'hidden',
                        verticalAlign: 'middle',
                        transition: 'width 0.3s ease, opacity 0.3s',
                        opacity: 0.5,
                    });

                    if (state) {
                        $icon.removeClass('far fal').addClass('fas');
                        $userIcon.removeClass('fa-user-plus').addClass('fa-user-check text-primary');
                        if ($el.data('text-favorited')) $text.text($el.data('text-favorited'));
                    } else {
                        $icon.removeClass('fas').addClass('far');
                        $userIcon.removeClass('fa-user-check text-primary').addClass('fa-user-plus');
                        if ($el.data('text-unfavorited')) $text.text($el.data('text-unfavorited'));
                    }

                    // Measure internal width after text change
                    const newWidth = $text.css('width', 'auto').width();
                    $text.css({width: oldWidth}); // Reset for transition

                    // Trigger CSS transition
                    $text.get(0).offsetHeight; // force reflow
                    $text.css({width: newWidth, opacity: 1});

                } else {
                    // Fallback for icons only
                    if (state) {
                        $icon.removeClass('far fal').addClass('fas');
                        $userIcon.removeClass('fa-user-plus').addClass('fa-user-check text-primary');
                    } else {
                        $icon.removeClass('fas').addClass('far');
                        $userIcon.removeClass('fa-user-check text-primary').addClass('fa-user-plus');
                    }
                }
            });
        };

        // Start animation and change state mid
        $icons.addClass('fa-flip').css('--fa-animation-iteration-count', 1).css('--fa-animation-duration', '0.5s');
        setTimeout(() => syncUI(predictedState), 400);
        setTimeout(() => $icons.removeClass('fa-flip'), 500);

        $.ajax({
            type: 'POST',
            url: `/ajax/favorite/${type}/${id}`,
            dataType: 'JSON',
            beforeSend: () => {
                $related.each(function () {$(this).css('pointer-events', 'none')})
            },
            complete: () => {
                $related.each(function () {$(this).css('pointer-events', 'auto')})
            },
            success: (data) => {
                // Confirm correct state
                if (data.state !== predictedState) {
                    syncUI(data.state);
                }
            },
            error: () => {
                // Revert if request failed
                syncUI(isFavorited);
                Swal.fire({
                    icon: 'error',
                    title: lang.get('javascript.error_generic'),
                    text: 'Brak uprawnień',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                });
            },
        });
    });

    // Parallaxie
    $('.parallaxie').parallaxie();

    $('a[href="' + decodeURIComponent(window.location.href) + '"]').each(function () {
        $(this).addClass('active');
    });

    // Keep tabs open
    window.openNestedTabHref = function openNestedTabHref(hash) {
        var res = hash.split("__");
        var res_length = res.length;
        $.each(res, function (index, element) {
            if (!element.startsWith('#')) {
                element = '#' + element;
            }

            $('[role="tab"][href="' + element + '"]').tab('show');
            if (index === (res_length - 1)) {
                const targetEl = $('[href="' + element + '"]:not(nav *)'); // Do not scroll to nav elements
                if (targetEl.length) {
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: targetEl.offset().top - 10 + 'px'
                        }, 'fast');
                    }, 500);
                }
            }
        });
    }

    $(document).on('click', '[data-open-nested-tab-href]', function () {
        openNestedTabHref($(this).data('openNestedTabHref'));
    });

    $(document).on('shown.bs.tab', '[role="tab"]', function (e) {
        if ($(e.target).parents('[role="tablist"]').data('no-hash') || $(e.target).attr('href') === undefined) {
            return;
        }

        var parentId = $(e.target).parents('[role="tabpanel"]')[0]?.id
        var grandparentId = $(e.target).parents('[role="tabpanel"]')[1]?.id
        var clickedId = $(e.target).attr('href').slice(1);
        var hash = '#' + (grandparentId ? grandparentId + '__' : '') + (parentId ? parentId + '__' : '') + clickedId

        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }
    });

    setTimeout(() => { // wait for the tab.shown listeners to initialize
        var hash = window.location.hash;
        if (hash) {
            // nested tabs
            if (hash.includes('__')) {
                openNestedTabHref(hash);
            }
            // single tab
            else {
                $('[role="tab"][href="' + hash + '"]').tab('show');
            }
        }
    }, 100)


    // Fullscreen menu
    $('.login-modal-trigger').click(function () {
        $.cleanOpenedWindows('login-modal');
        $('body').removeClass('mobile-search-open quick-public-profile-modal-open').toggleClass('login-modal-open');
        $('.mobile-trigger').addClass('collapsed');
        if ($('body').hasClass('login-modal-open')) {
            $('.login-modal-trigger').removeClass('collapsed');
        } else {
            $('.login-modal-trigger').addClass('collapsed');
        }
        $.fn.fixNavbarMobile();
    });

    // Express Public Profile Modal
    $(document).on('click', '.quick-public-profile-modal-trigger', (function () {
        $.cleanOpenedWindows('quick-public-profile-modal');
        $('body').removeClass('mobile-search-open login-modal-open').toggleClass('quick-public-profile-modal-open');
        if ($('body').hasClass('quick-public-profile-modal-open')) {
            $('.quick-public-profile-modal-trigger').removeClass('collapsed');
        } else {
            $('.quick-public-profile-modal-trigger').addClass('collapsed');
        }
        $.fn.fixNavbarMobile();
    }));

    // Fullscreen search
    $('.mobile-search-trigger').click(function () {
        $.cleanOpenedWindows('mobile-search');
        $('body').removeClass('login-modal-open').toggleClass('mobile-search-open');
        $('.mobile-trigger').addClass('collapsed');
        if ($('body').hasClass('mobile-search-open')) {
            $('.mobile-search-trigger').removeClass('collapsed');
        } else {
            $('.mobile-search-trigger').addClass('collapsed');
        }
        $.fn.fixNavbarMobile();
    });

    window.generateQrCode = function (config = {
        text: '',
        domTarget: null,
        title: '',
        subTitle: '',
        size: 256,
        logo: null,
        download: false,
        flyer: false
    }) {
        function roundedImage(ctx, x, y, width, height, radius) {
            ctx.beginPath(), ctx.moveTo(x + radius, y), ctx.lineTo(x + width - radius, y), ctx.quadraticCurveTo(x + width, y, x + width, y + radius), ctx.lineTo(x + width, y + height - radius), ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height), ctx.lineTo(x + radius, y + height), ctx.quadraticCurveTo(x, y + height, x, y + height - radius), ctx.lineTo(x, y + radius), ctx.quadraticCurveTo(x, y, x + radius, y), ctx.closePath();
        }

        const options = {
            text: config.text,
            width: config.size,
            height: config.size,
            colorDark: "#272524",
            colorLight: "#ffcc00",
            correctLevel: QRCode.CorrectLevel.H, // L, M, Q, H
            tooltip: true,
            // ====== dotScale
            dotScale: 0.6,
            dotScaleTiming: 0.6,
            dotScaleTiming_H: 0.6,
            dotScaleTiming_V: 0.6,
            dotScaleA: 1,
            dotScaleAO: undefined,
            dotScaleAI: undefined,
            // ====== Quiet Zone
            quietZone: 20,
            quietZoneColor: "rgba(0,0,0,0)",
            onRenderingEnd: function (options) {
                const lineWidth = 30
                const ctx = $(config.domTarget).find('canvas')[0].getContext('2d');

                // transparent border around canvas
                ctx.globalCompositeOperation = 'destination-out'
                roundedImage(ctx, -lineWidth / 2, -lineWidth / 2, ctx.canvas.width + lineWidth, ctx.canvas.height + lineWidth, 40);
                ctx.fillStyle = 'rgba(0,0,0,1)';
                ctx.strokeStyle = '#ff0000';
                ctx.lineWidth = lineWidth;
                ctx.stroke()
                ctx.save();

                const targetCanvas = $(config.domTarget).find('canvas')

                // add download button
                if (config.download) {
                    $(config.domTarget)
                        .append('<a class="qrcode-download btn btn-primary mt-2"><i class="fal fa-download me-2 "></i>' + lang.get('javascript.comment_share_cta.download') + '</a>')
                        .find('.qrcode-download')
                        .attr('href', targetCanvas[0].toDataURL("image/png"))
                        .attr('target', '_blank').attr('download', 'QR_MENU_' + (config.title ? _.snakeCase(config.title) : 'code') + '.png')
                }

                // add qrTable flyer download button
                if (config.flyer) {
                    const flyerImg = $('.flyer-preview')
                    mergeImages([
                        {
                            src: flyerImg.attr('src')
                        },
                        {
                            src: targetCanvas[0].toDataURL("image/png"),
                            x: flyerImg[0].naturalWidth / 2 - targetCanvas.width() / 2,
                            y: flyerImg[0].naturalHeight / 2 - targetCanvas.height() / 2,
                        }
                    ]).then(b64 => {
                        $(config.domTarget)
                            .append('<a class="flyer-download btn btn-primary"><i class="fal fa-download me-2 "></i>Pobierz ulotkę</a>')
                            .find('.flyer-download')
                            .attr('href', b64)
                            .attr('target', '_blank').attr('download', (config.title ? _.snakeCase(config.title) : 'stolik') + '_ulotka.png')


                    })
                }

            },
        };

        if (config.logo) {
            options.logo = config.logo;
            options.logoWidth = config.size / 3.2;
            options.logoHeight = config.size / 3.2;
            options.logoMaxWidth = undefined;
            options.logoMaxHeight = undefined;
            options.logoBackgroundTransparent = true;
        }

        if (config.title) {
            // todo: Longer names might not fit - add wrapping or truncate
            options.title = config.title;

            options.titleBackgroundColor = '#ffcc00';
            options.titleTop = 20;
            // solo title formatting
            if (config.subTitle) {
                options.titleHeight = 70;
                options.titleFont = 'normal normal bold 25px Roboto';
                options.titleColor = '#272524';
            } else {
                options.titleHeight = 40;
                options.titleFont = 'normal normal bold 25px Roboto';
                options.titleColor = 'rgba(0,0,0,0.70)';
            }

        }

        if (config.subTitle) {
            options.subTitle = config.subTitle;
            options.subTitleFont = 'normal normal normal 22px Roboto';
            options.subTitleColor = '#272524';
            options.subTitleTop = 45;
        }

        // Create QRCode Object
        new QRCode(config.domTarget, options);
    }


    // Ocenianie
    function attachStarrr() {
        $('.attach-starrr').each(function () {
            $(this).starrr({
                max: $(this).data('max') || 5,
                readOnly: $(this).data('vote') ? false : true,
                rating: $(this).data('rating') || void 0,
                fullClass: 'fas fa-star starrr',
                emptyClass: 'far fa-star starrr text-body-tertiary',
            });
            $(this).removeClass('attach-starrr').addClass('starrr')
            if ($(this).data('vote')) {
                $(this).on('starrr:change', function (e, value) {
                    $('input[name="' + $(this).data('vote') + '"]').val(value).change()
                });
            }
        });
    }

    attachStarrr();

    // REZERWACJA
    $(document).on('click', '.quick_booking_ajax', function () {
        Swal.close();
        var clicked = $(this);

        if (clicked.data('update-reservation')) {
            $.loadQuickBookingPanel('update', clicked.data('update-reservation'));
        } else {
            // auto set date & kind for nearest open slot
            var day = clicked.data('day') ? clicked.data('day') : $('.nearest_open_day[data-id="' + clicked.data('id') + '"]:first').data('day');
            var kind = clicked.data('kind') ? clicked.data('kind') : $('.nearest_open_day[data-id="' + clicked.data('id') + '"]:first').data('kind');
            var eventId = clicked.data('event-id');
            if (eventId && !kind) {
                kind = 'reservation';
            }
            $.loadQuickBookingPanel('create', clicked.data('id'), day, clicked.data('hour'), clicked.data('people'), kind, null, eventId);
        }
    });

    // Share reservation data-title, data-text, data-error
    $(document).on('click', '.share-reservation', function () {
        if (navigator.share) {
            navigator.share({
                title: $(this).data('title'),
                text: $(this).data('text'),
            }).catch((error) => console.log('Sharing failed', error));
        } else if (navigator.clipboard) {
            navigator.clipboard.writeText($(this).data('title') + ': ' + $(this).data('text'))
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: lang.get('javascript.sharing_error.generic') + ', więc skopiowaliśmy zaproszenie do schowka.',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: lang.get('javascript.sharing_error.generic'),
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                });
        } else {
            Swal.fire({
                icon: 'error',
                title: $(this).data('error') ?? lang.get('javascript.sharing_error.reservation'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            })
        }
    });

    // share comment social image
    $(document).on('click', '.share_comment', function () {
        $("#loading-indicator").fadeIn('fast');
        let filename = $(this).data('filename')

        fetch($(this).data('href'))
            .then(function (response) {
                $("#loading-indicator").fadeOut('fast');
                if (!response.ok) {
                    throw Error('Bad response')
                }
                return response.blob();
            })
            .then(function (blob) {
                const filesArray = [new File([blob], 'comment.png', {type: "image/png"})];
                let canShare = false;
                if ((navigator.canShare && navigator.canShare()) || navigator.share) {
                    canShare = true;
                }

                Swal.fire({
                    title: lang.get('javascript.comment_share_title'),
                    text: lang.get('javascript.comment_share_text'),
                    showCancelButton: canShare,
                    cancelButtonColor: '#11931b',
                    confirmButtonText: lang.get('javascript.comment_share_cta.download'),
                    cancelButtonText: lang.get('javascript.comment_share_cta.share'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        // download the image
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = filename;
                        a.click();
                        window.URL.revokeObjectURL(url);

                    } else if (result.isDismissed && result.dismiss === 'cancel') {
                        // share the image
                        navigator.share({
                            files: filesArray,
                        })
                    }
                })
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: lang.get('javascript.error_generic'),
                    text: error,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                })
            })
    });

    // Copy to clipboard
    $(document).on('click', '[data-copy-to-clipboard]', function () {
        if (navigator.clipboard) {
            const text = ($(this).data('copy-to-clipboard') == 'input') ? $(this).val() : $(this).data('copy-to-clipboard');

            navigator.clipboard.writeText(text)
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: lang.get('javascript.copy_success'),
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: lang.get('javascript.sharing_error.generic'),
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                });
        } else {
            Swal.fire({
                icon: 'success',
                html: 'Link: <a href="' + $(this).data('copy-to-clipboard') + '">' + $(this).data('copy-to-clipboard') + '</a>',
            })
        }
    });

    $('.quick_booking_cart_count').each(function () {
        updateCartCounter('cart_widget_company', $(this));
        window.setInterval(() => updateCartCounter('cart_widget_company', $(this)), 1500);
    });

    // Ajax forms
    $(document).on('change', 'form.form_ajax_on_change :input', function () {
        let form = $(this).closest('form');
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                var responseText = '';
                $.each(data.response, function (index, value) {
                    responseText += value + '<br/>';
                });
                Swal.fire({
                    icon: 'success',
                    title: responseText,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                })
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var responseJson = jQuery.parseJSON(jqXHR.responseText);
                var responseText = '';
                $.each(responseJson.response, function (index, value) {
                    responseText += value + '<br/>';
                });
                Swal.fire({
                    icon: 'error',
                    html: responseText,
                })
            },
            beforeSend: function () {
                $("#loading-indicator").fadeIn('fast');
            },
            complete: function () {
                $("#loading-indicator").fadeOut('fast');
            }
        });
    });

    // User reputation
    $(document).on('click', '.user-reputation-color-option', function () {
        $(this).closest('.user-reputation-color-dropdown').find('.user-reputation-color-input').val($(this).data('color')).trigger('change');
    });

    $(document).on('change', '.user-reputation-color-input[name="user:reputation_color"]', function () {
        const userReputationBootstrapColors = ['primary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];
        const userReputationAlertClasses = userReputationBootstrapColors.map(color => 'alert-' + color).join(' ');
        const userReputationBackgroundClasses = userReputationBootstrapColors.map(color => 'bg-' + color).join(' ');

        const color = $(this).val();

        if (!userReputationBootstrapColors.includes(color)) {
            return;
        }

        $(this)
            .closest('.form_editable')
            .find('.user-reputation-textarea')
            .removeClass(userReputationAlertClasses)
            .addClass('alert-' + color);

        $(this)
            .closest('.user-reputation-color-dropdown')
            .find('.user-reputation-color-current')
            .removeClass(userReputationBackgroundClasses + ' border-light')
            .addClass('bg-' + color + ' border-light');
    });

    // Form-editable
    $(document).on('change', '.form_editable input, .form_editable select, .form_editable textarea', function () {
        let name = $(this).attr('name');
        const disableLoading = $(this).parents('.form_editable').data('disable-loading') ?? false;

        if (name) {
            $.ajax({
                url: $(this).parents('.form_editable').data('save-url'),
                type: 'POST',
                dataType: 'json',
                data: {
                    'name': name,
                    'value': ($(this).is(':checkbox') ? ($(this).is(":checked") ? 1 : 0) : $(this).val()),
                    'details': $(this).data('details'),
                    'details2': $(this).data('details2'),
                    'option-details': $(this).data('details') || $(this).find(":checked").data('details'),
                },
                success: function (data) {
                    var responseText = '';
                    $.each(data.response, function (index, value) {
                        responseText += value + '<br/>';
                    });
                    Swal.fire({
                        icon: 'success',
                        title: responseText,
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    })
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var responseJson = jQuery.parseJSON(jqXHR.responseText);
                    var responseText = '';
                    $.each(responseJson.response, function (index, value) {
                        responseText += value + '<br/>';
                    });
                    Swal.fire({
                        icon: 'error',
                        html: responseText,
                    })
                },
                beforeSend: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeIn('fast');
                    }
                },
                complete: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeOut('fast');
                    }
                }
            });
        }
    });

    // reservation cancel reason choose

    $(document).on('click', '.reservation_cancel_reason_choose', function (e) {
        e.preventDefault();
        var form = $(this);

        function processCancelReason(reason) {
            if (reason) {
                form.prepend('<input type="hidden" name="reason" value="' + reason + '" />');
                form.submit();
            }
        };

        if (form.hasClass('reservation_cancel_company')) {
            var inputOptionsValues = {
                'Propozycja innej daty': lang.get('javascript.reservation_cancel_reason.propose'),
                'Zdublowana rezerwacja': lang.get('javascript.reservation_cancel_reason.duplicated'),
                'Pomyłka': lang.get('javascript.reservation_cancel_reason.mistake'),
                'other': lang.get('javascript.reservation_cancel_reason.other'),
            };

            if ($('.btn-status-canceled_company', form).data('is-past')) {
                inputOptionsValues = Object.assign({'Klient nie pojawił się': lang.get('javascript.reservation_cancel_reason.no_show')}, inputOptionsValues);
            }
        } else {
            var inputOptionsValues = {
                'Rezygnacja bez podania powodu': lang.get('javascript.reservation_cancel_reason.no_reason'),
                'Rezerwacja w innym terminie': lang.get('javascript.reservation_cancel_reason.another_time'),
                'Pomyłka': lang.get('javascript.reservation_cancel_reason.mistake'),
                'other': lang.get('javascript.reservation_cancel_reason.other'),
            };
        }


        Swal.fire({
            icon: 'question',
            title: lang.get('javascript.reservation_cancel_header'),
            input: 'select',
            inputOptions: inputOptionsValues,
            showCancelButton: true,
            cancelButtonText: lang.get('javascript.cancel'),
        }).then((result) => {

            switch (result.value) {
                case 'other':
                    Swal.fire({
                        title: lang.get('javascript.reservation_cancel_other.header'),
                        input: 'text',
                        showCancelButton: true,
                        cancelButtonText: lang.get('javascript.cancel'),
                        inputValidator: (value) => {
                            if (!value) {
                                return lang.get('javascript.reservation_cancel_other.no_input')
                            }
                        }
                    }).then((result) => {
                        processCancelReason(result.value);
                    });
                    break;
                case 'Propozycja innej daty':
                    let flatpickrInstance = [];
                    Swal.fire({
                        title: lang.get('javascript.reservation_cancel_propose.header'),
                        html: `<div class="input-group mb-3">
                               <label class="input-group-text" for="inputTime"><i class="far fa-clock"></i></label>
                               <input placeholder="` + lang.get('javascript.reservation_cancel_propose.placeholder') + `" type="text" id="inputTime" name="time" class="form-control form-control-lg quick_booking_flatpickr p-2" required />
                               </div>`,
                        stopKeydownPropagation: false,
                        showCancelButton: true,
                        cancelButtonText: lang.get('javascript.cancel'),
                        preConfirm: () => {
                            const minutes = flatpickrInstance['time'].selectedDates[0]?.getMinutes();

                            if ((typeof minutes == 'undefined') || !flatpickrInstance['time'].input.value) {
                                Swal.showValidationMessage(lang.get('javascript.reservation_cancel_propose.header'));
                                return false;
                            }
                            if (Date.parse(flatpickrInstance['time'].selectedDates[0]) < Date.now()) {
                                Swal.showValidationMessage(lang.get('javascript.reservation_cancel_propose.past'));
                                return false;
                            }

                            flatpickrInstance['time'].setDate(roundToMinutes(flatpickrInstance['time'].selectedDates[0], 15))
                        },

                        onOpen: () => {
                            flatpickrInstance['time'] = flatpickr(
                                Swal.getPopup().querySelector('#inputTime'),
                                {
                                    enableTime: true,
                                    locale: $('html').attr('lang') ?? 'pl',
                                    dateFormat: "Y-m-d H:i",
                                    time_24hr: true,
                                    minuteIncrement: 15,
                                    minDate: 'today',
                                }
                            )
                            Swal.showValidationMessage(lang.get('javascript.reservation_cancel_propose.15_min_slots'));
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            processCancelReason(lang.get('javascript.reservation_cancel_reason.propose') + ": " + flatpickrInstance['time'].input.value);
                        }
                    });

                    break;

                default:
                    processCancelReason(result.value);
            }

        });
    });

    function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    function deg2rad(deg) {
        return deg * (Math.PI / 180)
    }

    function getUrlParam(name) {
        var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return (results && results[1]) || undefined;
    }

    function getUrlSegment(num) {
        num += 2;
        var segments = window.location.href.toString();
        if (segments.indexOf('?') > -1) {
            segments = segments.substring(0, window.location.href.indexOf("?"));
        }
        segments = segments.split('/');
        if (segments[num] != undefined) {
            return segments[num];
        }
        return undefined;
    }

    function isLocationFilterSet() {
        return ((typeof (getUrlParam('search_filter_location')) !== 'undefined') || (getUrlSegment(1) == 'restauracje' && getUrlSegment(2) == 'w' && getUrlSegment(3)));
    }

    var geo = navigator.geolocation;
    if (geo && !window.location.pathname.endsWith('/profile') && typeof cities !== 'undefined') {
        geo.getCurrentPosition(location => {
                var nearest_distance = 40000;
                var nearest_city = null;

                $.each(cities, function (index, value) {
                    var city_distance = getDistanceFromLatLonInKm(location.coords.latitude, location.coords.longitude, parseFloat(value.latitude.replace(',', '.').replace(' ', '')), parseFloat(value.longitude.replace(',', '.').replace(' ', '')));
                    if (city_distance < nearest_distance) {
                        nearest_distance = city_distance;
                        nearest_city = value;
                        nearest_city.distance = nearest_distance;
                        nearest_city.map = 'https://www.google.com/maps/search/?api=1&query=' + nearest_city.latitude.toString().replace(",", ".") + ',' + nearest_city.longitude.toString().replace(",", ".");
                    }
                });

                location.coords.map = 'https://www.google.com/maps/search/?api=1&query=' + location.coords.latitude.toString().replace(",", ".") + ',' + location.coords.longitude.toString().replace(",", ".")

                $('meta[name=location]').data('location', location.coords).data('nearest_city', nearest_city);

                // set city only if not choosen previously
                if (nearest_city.value && (location.coords.accuracy < 50000) && !isLocationFilterSet()) {
                    $('select[name="search_filter_location"]').val(nearest_city.value).trigger('change.select2');
                    $.loadRecommendedBoxLocation(nearest_city.value, false);
                    $("meta[name='location']").attr("content", nearest_city.value);
                }

                if ((location.coords.accuracy < 1000)) {
                    window.setInterval(function () {
                        $('.calculate_distance').each(function () {
                            if (!$(this).data('calculated')) {
                                distance = getDistanceFromLatLonInKm(location.coords.latitude, location.coords.longitude, $(this).data('latitude'), $(this).data('longitude')) * 1000;
                                if (distance > 1000) {
                                    distance_txt = parseFloat((distance / 1000)).toFixed(2) + ' km';
                                } else {
                                    distance_txt = Math.round(distance) + ' m';
                                }
                                $(this).data('calculated', true).html(distance_txt + '<i class="fal fa-sm fa-location-arrow mx-1"></i>');
                            }
                        });
                    }, 2000);
                }

            },
            () => {
                $.loadRecommendedBoxLocation(undefined, false);
            });
    }

    // WEB SHARE API button
    $('.share-page-button').click(function () {
        if (navigator.share) {
            navigator.share({
                title: $(this).data('title') || $('meta[property="og:title"]').attr('content'),
                text: $(this).data('text') || $('meta[property="og:description"]').attr('content'),
                url: $(this).data('url') || $('meta[property="og:url"]').attr('content'),
            }).catch((error) => console.log('Sharing failed', error));
        } else if (navigator.clipboard) {
            navigator.clipboard.writeText($(this).data('url') || $('meta[property="og:url"]').attr('content'))
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: lang.get('javascript.sharing_error.generic') + ', więc skopiowaliśmy link do schowka. Możesz udostępnić go gdzie chcesz.',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: lang.get('javascript.sharing_error.generic'),
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                });
        } else {
            Swal.fire({
                icon: 'error',
                title: lang.get('javascript.sharing_error.generic'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            })
        }
    });

    // Smooth scroll
    $('.smooth_scroll:not([href=\\#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 70
                }, 400);
                return false;
            }
        }
    });

    // smart collapse with more/less
    $('.collapse-smart').each(function () {
        if ($(this).height() < 250) {
            // $(this).removeClass('collapse-preview-wrap collapse');
        } else {
            var id = $.randomString(10);
            let show = $(this).data('expanded') ? true : false;
            $(this)
                .addClass('collapse with-preview ' + (show ? 'show' : ''))
                .siblings('.btn_autotext').removeClass('d-none')
        }
    });

    window.lazyloadContainer = function (event) {
        const sourceElement = $(this);
        const targetContainer = $(sourceElement.data('lazyload-target'));

        if ((sourceElement.data('lazyload-src') === undefined) || (sourceElement.data('lazyload-target') === undefined)) {
            return false;
        }

        if (targetContainer.find('.lazyloaded').length === 0) {
            targetContainer.append('<div class="lazyloaded"></div>');
        }

        if (event.data?.unbind) {
            sourceElement.unbind(event.data.unbind);
        }

        $.ajax({
            url: sourceElement.data('lazyload-src'),
            dataType: 'html',
            beforeSend: function () {
                $('.loader', targetContainer).toggleClass('d-none', false);
                $('.lazyloaded', targetContainer).toggleClass('d-none', true);
            },
            complete: function () {
                $('.loader', targetContainer).toggleClass('d-none', true);
                $('.lazyloaded', targetContainer).toggleClass('d-none', false);
            }
        })
            .done(function (data) {
                let dataHtml = $(data).fadeOut(0)
                targetContainer.find('.lazyloaded').html(dataHtml);
                dataHtml.fadeIn();
            })
            .fail(function (response) {
                if (event.data?.unbind) {
                    sourceElement.on(event.data.unbind, lazyloadContainer);
                }

                Swal.fire({
                    icon: 'error',
                    title: lang.get('javascript.error_generic'),
                    text: response.status,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                })
            });
    }

    function lazyLoadNearestHours(element) {
        var wrapper = element.parents('.nearest_hours').first();

        if (!wrapper.length || wrapper.data('isLoading')) return
        wrapper.data('isLoading', true)
        var availableHours = $('.nearest_hours_available, .nearest_hours_available_lazyload', wrapper)
        var company_id = wrapper.data('id');
        var half_column = wrapper.data('half-column');
        var swiper = wrapper.data('swiper');
        element.addClass('active').siblings('.kind-icon').removeClass('active');
        var active_kind = $('.kind-icon.active', wrapper).data('kind');

        var searchParams = new URLSearchParams(window.location.search)

        $.ajax({
            url: wrapper.data('action'),
            type: "POST",
            data: {
                'kind': active_kind,
                'half_column': half_column,
                'swiper': swiper,
                'search_filter_date': searchParams.get('search_filter_date'),
                'search_filter_time': searchParams.get('search_filter_time'),
            },
            beforeSend: function () {
                if (availableHours.hasClass('nearest_hours_available')) {
                    availableHours.html('<div class="placeholder rounded py-2 w-75 mt-2 d-none d-lg-block ms-4"></div><div class="placeholder rounded py-2 w-50 mt-2 ms-4"></div><div class="mt-3 ms-4"><div class="rounded me-1 px-4 py-3 placeholder"></div><div class="rounded mx-1 px-4 py-3 placeholder"></div><div class="rounded ms-1 px-4 py-3 placeholder"></div></div>')
                }
            },
            complete: function () {
                wrapper.removeData('isLoading')
                // $("#loading-indicator").fadeOut('fast');
            },
            success: function (data) {
                availableHours.replaceWith(data);

                // auto set kind for corresponding quick bookin buttons
                $('.btn.quick_booking_ajax[data-id="' + company_id + '"]').data('kind', active_kind);

                // reinit swiper
                initSwiperHours();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                Swal.fire({
                    icon: 'error',
                    html: lang.get('javascript.error_generic'),
                })
            }
        });
    }

    // nearest hours ajax
    $(document).on('click', '.kind-icon:not([disabled])', function (e) {
        lazyLoadNearestHours($(this))
    });

    // Scroll to top
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            // company page fix
            if ($('.sticky-company-booking-mobile:visible').length) {
                $('.scroll_top_arrow').css('bottom', '80px');
            }

            $('.scroll_top_arrow:hidden').fadeIn();
        } else {
            $('.scroll_top_arrow').fadeOut();
        }
    });
    $(function () {
        $(".scroll_top_arrow").click(function () {
            $("html,body").animate({scrollTop: $("body").offset().top}, "1000");
            return false;
        })
    })

    // Add optional (+ add) input to selects
    $('[data-select-with-optional-input]').selectWithOptionalInput();

    $('.theme-switch').click(function () {
        setTheme($('html').attr('data-bs-theme') == 'light' ? 'dark' : 'light');
    })

    // Remembers closed Bootstrap 5 toasts with cookies
    window.bootstrap5CookieToasts = (function () {

        const COOKIE_VALUE = 1;
        const COOKIE_PREFIX = 'TOAST-REMEMBER-CLOSING-';

        function setCookie(name, value, expirationInDays) {
            const date = new Date();
            date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
            document.cookie = name + '=' + value + '; ' + 'expires=' + date.toUTCString() + ';path=/;secure';
        }

        function cookieExists(name) {
            return (document.cookie.split('; ').indexOf(name + '=' + COOKIE_VALUE) !== -1);
        }

        function getCookieName(element) {
            return COOKIE_PREFIX + element.getAttribute('data-toast-id');
        }

        function showToast(element) {
            element.classList.add('show');
            element.addEventListener('hidden.bs.toast', function () {
                setCookie(getCookieName(element), COOKIE_VALUE, 7);
                Swal.fire({
                    icon: 'success',
                    title: 'Szkoda, spróbujemy za 7 dni',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                })
            });
        }

        const toasts = document.getElementsByClassName('toast toast-remember-closing');
        for (let i = 0; i < toasts.length; ++i) {
            if (!toasts[i].classList.contains('show')) {
                if (!cookieExists(getCookieName(toasts[i]))) {
                    showToast(toasts[i]);
                }
            }
        }
    })();

    // Highlighted hours slots for current time + search
    setInterval(function () {
        higlightSuggestedSlotHours();
    }, 60000);

    setTimeout(function () {
        higlightSuggestedSlotHours();
    }, 2000);

    $(document).on('change', '[name="search_filter_time"], [name="search_filter_date"]', function () {
        higlightSuggestedSlotHours();
    });

    // Lightbox Gallery
    new SimpleLightbox('.lightbox', {
        captionSelector: 'self',
        scrollZoomFactor: 0.1,
        uniqueImages: true,
        widthRatio: 0.98,
    });

    // Counter animation
    function setIntervalAndExecute(fn, t) {
        fn();
        return (setInterval(fn, t));
    }

    $('.counter_animation').each(function () {
        var step_min = parseInt($(this).data('step-min'));
        var step_max = parseInt($(this).data('step-max'));
        var duration = parseInt($(this).data('duration'));
        var pause = parseInt($(this).data('pause'));

        setIntervalAndExecute(() => {
            var currentValue = parseInt($(this).text().replace(/\s/g, ''));

            if ($(this).data('initial')) {
                var newValue = currentValue + Math.floor(Math.random() * (step_max - step_min + 1) + step_min);
            } else {
                $(this).data('initial', currentValue);
                var newValue = currentValue;
            }

            $(this).animate({
                'num': newValue
            }, {
                duration: duration,
                easing: 'linear',
                step: function (num) {
                    // if(num < $(this).data('initial')){
                    //     num = $(this).data('initial');
                    // }
                    $(this).text(Math.ceil(num).toLocaleString('pl-PL'));
                }
            });
        }, pause);
    });

    // Required input based on checkbox state
    $(document).on('change', '[data-required-when-checked]', function () {
        $($(this).data('required-when-checked')).prop('required', $(this).is(':checked'));
    });

    $('.generate-qr-code').each(function () {
        generateQrCode({
            text: $(this).data('download-href'),
            size: $(this).data('size') || 150,
            domTarget: this,
        })
    });

    // AJAX: Load user social card
    const loadUserSocialCard = function () {
        $('.user-social-card-ajax-container').each(function () {
            const container = $(this);
            if (container.data('loading') || container.data('loaded')) return;

            container.data('loading', true);
            $.ajax({
                url: container.data('ajax-url'),
                type: 'GET',
                data: {
                    profile: container.data('profile')
                },
                dataType: 'html',
                success: function (html) {
                    container.html(html);
                    container.data('loaded', true);
                    container.data('loading', false);
                    container.find('[data-bs-toggle="tooltip"]').tooltip();

                    if (typeof window.initAvatarDropzone === 'function') {
                        window.initAvatarDropzone(container);
                    }
                },
                error: function () {
                    container.data('loading', false);
                    console.error('Failed to load social card');
                }
            });
        });
    };

    loadUserSocialCard();
});

// Reservation chats
function getReservationChats(ids) {
    $.ajax({
        type: "POST",
        url: '/ajax/reservation/get_chats',
        data: {ids: ids},
        success: function (response) {
            $.each(response, function (id, chatData) {
                $('.comments_reservation_count_' + id).html(chatData.count).attr('title', chatData.last_updated_at);
                $('.comments_reservation_last_updated_at_' + id).html(chatData.last_updated_at);
                if (chatData.count) {
                    $('.reservation_chat_wrap[data-id="' + id + '"]').html(`<div class="d-flex justify-content-center align-items-center flex-column">` + chatData.view + `</div>`).scrollTop($('.reservation_chat_wrap[data-id="' + id + '"]')[0].scrollHeight);
                }
            });
        }
    });
}

setInterval(function () {
    var chatIds = [];
    $('.reservation_chat_wrap').each(function () {
        if ($(this).data('autorefresh')) {
            chatIds.push($(this).data('id'));
        }
    });
    if (chatIds.length > 0) {
        getReservationChats(chatIds);
    }
}, 30000);

$(document).on('submit', 'form.reservation_chat_form', function (e) {
    e.preventDefault();
    var form = $(this);
    $.ajax({
        url: form.attr('action'),
        type: "POST",
        data: form.serialize(),
        beforeSend: function () {
            $("#loading-indicator").fadeIn('fast');
        },
        complete: function () {
            $("#loading-indicator").fadeOut('fast');
        },
        success: function (response) {
            getReservationChats([form.data('id')]);
            form.find('textarea').val('');
            $(document).trigger('refreshConversationList');
        },
        error: function (data) {
            let errors = '';
            data.responseJSON.errors.content.forEach(msg => {
                errors += '<br>' + msg;
            })
            Swal.fire({
                icon: 'error',
                html: lang.get('javascript.error_generic') + errors,
            })
        }
    });
})
